module.exports = __webpack_public_path__ + "static/d2-0a0aaba33551113aa1b25fc67e0ddd2a.png";